import { Directive, HostListener, Input, OnDestroy, Renderer2 } from '@angular/core';

@Directive({
    selector: '[appTooltip]'
})
export class TooltipDirective implements OnDestroy
{
    @Input('appTooltip') text = '';
    @Input() tooltipDelay = 800;

    private tooltipEl: HTMLElement | null = null;
    private timer: ReturnType<typeof setTimeout> | null = null;
    private mouseX = 0;
    private mouseY = 0;

    constructor(private renderer: Renderer2) { }

    @HostListener('mouseenter', [ '$event' ])
    onMouseEnter(event: MouseEvent): void
    {
        this.mouseX = event.clientX;
        this.mouseY = event.clientY;
        this.timer = setTimeout(() => this.show(), this.tooltipDelay);
    }

    @HostListener('mousemove', [ '$event' ])
    onMouseMove(event: MouseEvent): void
    {
        this.mouseX = event.clientX;
        this.mouseY = event.clientY;
    }

    @HostListener('mouseleave')
    onMouseLeave(): void
    {
        this.clear();
    }

    ngOnDestroy(): void
    {
        this.clear();
    }

    private show(): void
    {
        if (!this.text) { return; }

        const el: HTMLElement = this.renderer.createElement('div');
        this.tooltipEl = el;
        this.renderer.addClass(el, 'app-tooltip');
        this.renderer.setProperty(el, 'textContent', this.text);
        this.renderer.setStyle(el, 'visibility', 'hidden');
        this.renderer.appendChild(document.body, el);

        const gap = 24;
        const tooltipWidth = el.offsetWidth;
        const tooltipHeight = el.offsetHeight;

        const centeredLeft = this.mouseX - tooltipWidth / 2;
        const left = Math.max(0, Math.min(centeredLeft, window.innerWidth - tooltipWidth));

        const fitsBelow = this.mouseY + gap + tooltipHeight <= window.innerHeight;
        const top = fitsBelow ? this.mouseY + gap : this.mouseY - gap - tooltipHeight;

        this.renderer.setStyle(el, 'left', `${ left }px`);
        this.renderer.setStyle(el, 'top', `${ top }px`);
        this.renderer.setStyle(el, 'visibility', 'visible');
    }

    private clear(): void
    {
        if (this.timer)
        {
            clearTimeout(this.timer);
            this.timer = null;
        }
        if (this.tooltipEl)
        {
            this.renderer.removeChild(document.body, this.tooltipEl);
            this.tooltipEl = null;
        }
    }
}
